import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const NoteModal = ({ isOpen, toggle, recordingId, onNoteSaved, title = 'Add Note' }) => {
  const [note, setNote] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${BASE_URL}web/recordingNotes`, {
        recordingId,
        note
      });
      if (response.data.success) {
        onNoteSaved();
        toggle();
      } else {
        console.error('Failed to save note:', response.data.errorString);
      }
    } catch (error) {
      console.error('Error saving note:', error);
    }
  };

  useEffect
  (() => {
    setNote('');
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="note">Note</Label>
            <Input
              type="textarea"
              name="note"
              id="note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows="5"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancel</Button>
          <Button color="primary" type="submit">Save Note</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default NoteModal;